import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { PLACEHOLDER_CA } from "../../lib/memeData";

export const ContractCard = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(PLACEHOLDER_CA);
      setCopied(true);
      toast.success("COPIED!! you did a good job 🎉", {
        description: "now go ape on pump.fun. 🪖",
      });
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("oop, your browser said no. try again retard 🙏");
    }
  };

  return (
    <section className="px-5 md:px-10 py-10" data-testid="contract-section">
      <div className="max-w-4xl mx-auto crayon-card relative px-6 md:px-10 py-8 rotate-1">
        <span className="tape" style={{ background: "rgba(230, 57, 70, 0.55)" }} />
        <div className="text-center">
          <p className="font-display text-3xl md:text-4xl text-[#E8742C]">
            📜 contract address
          </p>
          <p className="text-base md:text-lg text-[#1A1A1A]/70 mb-5">
            we're live on solana ✦ paste this into pump.fun and ape responsibly (don't)
          </p>

          <div
            className="flex flex-col md:flex-row items-stretch gap-3 bg-[#FFF5E5] border-4 border-[#1A1A1A] rounded-2xl p-3 md:p-4"
            data-testid="ca-row"
          >
            <code
              className="flex-1 text-sm md:text-base font-mono break-all text-[#1A1A1A] px-3 py-2 text-left bg-white border-2 border-dashed border-[#1A1A1A]/40 rounded-xl"
              data-testid="ca-text"
            >
              {PLACEHOLDER_CA}
            </code>
            <button
              type="button"
              onClick={handleCopy}
              className="crayon-btn"
              data-testid="copy-ca-button"
            >
              {copied ? (
                <>
                  <Check className="w-6 h-6" /> copied!
                </>
              ) : (
                <>
                  <Copy className="w-6 h-6" /> copy CA
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContractCard;
